import { render, staticRenderFns } from "./PerkItem.vue?vue&type=template&id=ac546a84"
import script from "./PerkItem.vue?vue&type=script&lang=js"
export * from "./PerkItem.vue?vue&type=script&lang=js"
import style0 from "./PerkItem.vue?vue&type=style&index=0&id=ac546a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports